import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import DisplayCard from '../../../components/displaycard';

import Auth from '../../../data/auth-service';
import Permissions from '../../../data/permissions';

const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';

const policies = [
    {
        title: 'Geo IP',
        description: 'Enrich data with geographic location',
        img: '/images/geoip-bg.png',
        route: '/policies/sensor/geo_ip',
        perm: { GeoIPPolicy: [...Permissions.Policies.Sensor.GeoIPPolicy] },
    },
    {
        title: 'Exports',
        description: 'Configure sensor exports',
        img: '/images/exports.png',
        route: '/policies/sensor/exports',
        perm: { ExportsPolicy: [...Permissions.Policies.Sensor.ExportsPolicy] },
    },
    {
        title: 'Packet Capture',
        description: 'Use BPF filters to narrow packet collection',
        img: '/images/pcap.png',
        route: '/policies/sensor/pcap',
        perm: { PcapPolicy: [...Permissions.Policies.Sensor.PcapPolicy] },
    },
    {
        title: 'Data Tuning',
        description: 'Create gator filter expressions to tune and tag data',
        img: '/images/data-tuning.png',
        route: '/policies/sensor/data_tuning',
        perm: { DataTuningPolicy: [...Permissions.Policies.Sensor.DataTuningPolicy] },
    },
    {
        title: 'File Hash',
        description: 'Add MD5 file hash source lists',
        img: '/images/file-hash-blue.png',
        route: '/policies/sensor/file_hash',
        perm: { FileHashPolicy: [...Permissions.Policies.Sensor.FileHashPolicy] },
    },
    {
        title: 'Configuration',
        description: 'Update sandboxing and SNMP configurations',
        img: '/images/config.png',
        route: '/policies/sensor/configuration',
        perm: { ConfigPolicy: [...Permissions.Policies.Sensor.ConfigPolicy] },
    },
    {
        title: 'Upgrade',
        description: 'Schedule and deploy upgrades to one or more sensors',
        img: '/images/sensor-upgrade.png',
        route: '/policies/sensor/upgrade',
        hide: MC2CHECK,
        perm: { UpgradePolicy: [...Permissions.Policies.Sensor.UpgradePolicy] },
    },
];

const PolicySensor = (props) => {
    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {policies.filter(o => Auth.perm(o.perm)).map((p, i) => {
                    return (
                        <Grid item xl={3} lg={4} key={`policies-zeek-${i}`}>
                            <DisplayCard aria-label={p.title} {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default PolicySensor;
